<template>
  <div v-clickout="() => (active = false)" class="dropdown-container">
    <div class="dropdown" :class="{ active: active }" :style="{ height: `${config.inputSize}px` }">
      <div
        class="input"
        :style="{ height: `${config.inputSize - 2}px` }"
        :class="{ active: config.active, red: config.color === 'red' || !config.color }"
        @click="active ? (active = false) : (active = true)"
      >
        <slot name="placeholder" :is-placeholder="!value && value !== 0" :value="!value && value !== 0 ? placeholder : value"></slot>
        <div class="icon"></div>
      </div>

      <div
        class="dropdown-content"
        :style="{
          height: active && getValues.length ? `${config.inputSize * getValues.length + 2}px` : 0,
          'max-height': `${config.inputSize * 6 + 2}px`,
        }"
      >
        <div
          v-for="choice in getValues"
          :key="JSON.stringify(choice)"
          class="input choice"
          :style="{ height: `${config.inputSize}px` }"
          :class="{ active: config.active, highlight: choice === value }"
          @click="setValue(choice)"
        >
          <slot name="choices" :choice="choice"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    values: {
      type: Array,
      required: true,
    },

    placeholder: {
      type: String,
      required: true,
    },

    onChange: {
      type: Function,
      required: true,
    },

    value: {
      required: true,
    },

    config: {
      type: Object,
      required: false,

      default: () => ({
        inputSize: 48,
        showActivatedOnly: false,
      }),
    },
  },

  data() {
    return {
      active: false,
    };
  },

  computed: {
    getValues() {
      if (this.config.showActivatedOnly) {
        return this.values.filter(choice => choice.isActivated || choice.isEnabled);
      }
      return this.values;
    },
  },

  methods: {
    setValue(value) {
      this.active = false;
      this.onChange(value);
    },

    clickout() {
      this.active = false;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
* {
  box-sizing: border-box;
  transition: all 0.1s ease-in-out;
}

.dropdown-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .input {
    width: 100%;
    margin: 0 0 16px;
    height: 100%;
    padding: 4px 10px;
    color: colors.$text-color;
    border-radius: 4px;
    background: colors.$white-color;
    white-space: nowrap;

    &.active {
      border-radius: 4px;
      background: colors.$white-color;
      padding: 4px 10px;
    }

    &:last-child {
      margin: 0;
    }

    &::placeholder,
    .placeholder {
      color: colors.$lightgrey-color;
    }
  }

  .dropdown {
    width: 100%;
    position: relative;
    margin-bottom: 16px;
    height: 100%;
    border: solid 1px colors.$lightgrey-color;
    border-radius: 4px;

    .input {
      color: colors.$lightgrey-color;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      font-size: 14px;
      line-height: 16px;
      color: colors.$black-color;
      margin-bottom: 0;
      height: 100%;
      padding: 4px 10px;
      border-radius: 4px;
      background: colors.$white-color;

      .value {
        &.grey {
          color: colors.$lightgrey-color;
        }
      }

      &.red {
        &.active {
          color: colors.$red-color;
        }
      }

      .icon {
        position: absolute;
        height: 0;
        width: 0;
        border-top: 7px solid colors.$lightgrey-color;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        right: 12px;
        border-radius: 0.4px;
        transition: all 0.3s ease-in-out;
      }

      &:hover {
        cursor: pointer;
      }
    }

    .dropdown-content {
      position: absolute;
      top: 100%;
      left: -1px;
      right: -1px;
      height: 0;
      overflow: hidden;
      transition:
        all 0.2s ease-in-out,
        opacity 0.05s ease-in-out;
      opacity: 0;
      background: colors.$white-color;
      border: solid 1px colors.$lightgrey-color;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      box-sizing: border-box;

      .choice {
        margin: 0;
      }
    }

    &.active {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      .icon {
        transform: rotate(180deg);
      }

      .dropdown-content {
        overflow: hidden;
        z-index: 1400;
        opacity: 1;
        transition:
          all 0.2s ease-in-out,
          opacity 0.05s ease-in-out;
        overflow-y: auto;

        &::-webkit-scrollbar-thumb:vertical {
          border-radius: 0;
        }

        .choice {
          background: colors.$white-color;
          transition: opacity 0.05s ease-in-out;

          &.highlight {
            background: rgba(colors.$lightblue-color, 0.05);
          }

          &:hover {
            color: colors.$black-color;
            opacity: 0.8;
            background: rgba(colors.$lightgrey-color, 0.1);
          }

          &:not(:first-child) {
            border-top: solid 1px rgba(colors.$lightgrey-color, 0.3);
            border-radius: 0;
          }
        }

        .value {
          color: colors.$red-color;

          &.grey {
            color: colors.$lightgrey-color;
          }

          &.black {
            color: colors.$black-color;
          }
        }
      }
    }
  }
}
</style>
